import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M19.81,16.89a6,6,0,0,1-4.8-2.4,2,2,0,1,1,3.2-2.4,2,2,0,0,0,2.79.4l3.88-2.91a1.94,1.94,0,0,0,.77-1.31,2,2,0,0,0-3.09-1.92l-1.2,1.11a2,2,0,1,1-2.72-2.92L20.09,3.2a6,6,0,0,1,7.19,9.59l-3.88,2.9A5.94,5.94,0,0,1,19.81,16.89Z"/><path d="M8,30a6,6,0,0,1-4.87-9.46L4.4,18.81a2,2,0,1,1,3.2,2.38l-1.26,1.7a2,2,0,0,0,3.28,2.27l2.8-3.95a2,2,0,0,0,.34-1.48A2,2,0,0,0,12,18.44a2,2,0,0,1,2.32-3.26,6,6,0,0,1,1.41,8.35l-2.8,3.95A6,6,0,0,1,9,29.92,7,7,0,0,1,8,30Z"/><path d="M11.1,13.06a2,2,0,0,1-1.4-.57L6.59,9.42A2,2,0,0,1,9.41,6.58l3.1,3.06a2,2,0,0,1,0,2.83A2,2,0,0,1,11.1,13.06Z"/><path d="M8.22,17.1A2.22,2.22,0,0,1,7.71,17L3.5,15.94a2,2,0,1,1,1-3.88l4.22,1.11a2,2,0,0,1-.5,3.93Z"/><path d="M15,10.21a2,2,0,0,1-1.93-1.48l-1.15-4.2a2,2,0,1,1,3.85-1.06l1.16,4.2A2,2,0,0,1,15,10.21Z"/>';
export var BrokenLinkSVG = function BrokenLinkSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
BrokenLinkSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(BrokenLinkSVG);